import axios from 'axios';
import { forceLoad } from '../helpers/AbloyKeyHelper';
export const UPSERT_ABLOY_KEY   = 'UPSERT_ABLOY_KEY';
export const KEY_IS_BUSSY       = 'KEY_IS_BUSSY'

export const ADD_LEASE_KEY_TO_RECEIVED = 'ADD_LEASE_KEY_TO_RECEIVED';
export const ADD_LEASE_KEY_TO_GIVEN    = 'ADD_LEASE_KEY_TO_GIVEN';
export const RECEIVED_LEASE_KEY         = 'RECEIVED_LEASE_KEY';
export const NOT_RECEIVED_LEASE_KEY     = 'NOT_RECEIVED_LEASE_KEY';
export const LOOSE_LEASE_KEY           = 'LOOSE_LEASE_KEY';
export const RETURN_LEASE_KEY          = 'RETURN_LEASE_KEY';
export const REMOVE_LEASE_KEY          = 'REMOVE_LEASE_KEY';
export const BROKEN_LEASE_KEY          = 'BROKEN_LEASE_KEY';

export const FETCH_RECEIVED_KEYS      = 'FETCH_RECEIVED_KEYS';
export const FETCH_GIVEN_KEYS         = 'FETCH_GIVEN_KEYS';
export const FETCH_LOST_KEYS          = 'FETCH_LOST_KEYS';
export const FETCH_BROKEN_KEYS        = 'FETCH_BROKEN_KEYS';
export const TRANSFER_READY           = 'TRANSFER_READY';
export const SUBMIT_COMMENT           = 'SUBMIT_COMMENT';

export const SET_KEY_UPDATING_STATUS_BY_ID = 'SET_KEY_UPDATING_STATUS_BY_ID'
export const SET_KEY_UPDATING_STATUS_BY_STAMP = 'SET_KEY_UPDATING_STATUS_BY_STAMP'

const csrf_token = $("meta[name=csrf-token]").attr('content');
const axiosClient = axios.create({
  baseUrl: 'http://localhost:3000',
  headers: {
    "x-csrf-token": csrf_token,
    "Content-Type": "application/json"
  }
});

const force = forceLoad()

const checkStatusRequests = {}

const fatalErrorMsg = "Jokin meni pieleen, ole hyvä ja päivitä sivu uudelleen"

//action creators

/* abloy keys */
const upsertAbloyKey = (key) => {
  return {
    type: UPSERT_ABLOY_KEY,
    payload: key
  }
}

const fetchAbloyKeys = (leaseId) =>
  async dispatch => {
    const response = await axiosClient.get(`/admin/leases/${leaseId}/abloy_keys.json?force=${force || ''}`, {});
    const data = response.data && response.data.abloy_keys ? response.data.abloy_keys : null;

    lodash.each(data, (key) => {
      dispatch({
        type: UPSERT_ABLOY_KEY,
        payload: key
      })
    })
  };

const fetchAbloyKeyById = (leaseId, apartmentKeyId, abloyKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, true))

    const response = await axiosClient.get(`/admin/leases/${leaseId}/abloy_keys/${abloyKey.identity}.json?force=true`, {});
    const data = response.data && response.data.abloy_key_details ? response.data.abloy_key_details : null;

    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, false))

    dispatch({
      type: UPSERT_ABLOY_KEY,
      payload: data
    })
  };

const _checkAbloyKeyStatus = async (leaseId, abloyKeyId) => {
  const promise = new Promise(async (resolve) => {
    const response = await axiosClient.get(`/admin/leases/${leaseId}/abloy_keys/${abloyKeyId}/status.json`);
    const status = response.data && response.data.status ? response.data.status : null;
    if (status == 'ready') {
      resolve(true)
    } else {
      setTimeout(function() {
        resolve(_checkAbloyKeyStatus(leaseId, abloyKeyId))
      }, 1000);
    }
  })

  return promise
}

const _waitForAbloyKeyReadyToProgramm = async (leaseId, abloyKeyId, time = 1000, force = null) => {
  const promise = new Promise(async (resolve, reject) => {
    const response = await axiosClient.get(`/admin/leases/${leaseId}/abloy_keys/${abloyKeyId}.json?force=${force || ''}`);
    const data = response.data && response.data.abloy_key_details ? response.data.abloy_key_details : null;

    if (time > 3000) {
      return reject(false)
    }

    if (data && data.ready_to_programm) {
      resolve(data)
    } else {
      setTimeout(function() {
        resolve(_waitForAbloyKeyReadyToProgramm(leaseId, abloyKeyId, time + 1000, true))
      }, time);
    }
  })

  return promise
}

const checkAbloyKeyStatus = (leaseId, apartmentKeyId, abloyKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, true))

    const abloyKeyId = abloyKey.identity
    //debugger
    if (checkStatusRequests[abloyKeyId]) {
      return
    }
    checkStatusRequests[abloyKeyId] = _checkAbloyKeyStatus(leaseId, abloyKeyId)

    await checkStatusRequests[abloyKeyId]

    checkStatusRequests[abloyKeyId] = null

    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, false))

    dispatch(fetchAbloyKeyById(leaseId, apartmentKeyId, abloyKey))
  }

const markAbloyKeyAsBusy = (abloyKey) => {
  return {
    type: KEY_IS_BUSSY,
    identity: abloyKey.identity,
    busy: true
  }
}

const removeAccessAbloyKey = (leaseId, customerId, apartmentKeyId, abloyKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, true))
    dispatch(markAbloyKeyAsBusy(abloyKey))

    try {
      const body = JSON.stringify({
        hand_in: {
          customer_id: customerId,
          apartment_key_id: apartmentKeyId,
          version: abloyKey.version
        }
      });
      await axiosClient.post(`/admin/leases/${leaseId}/abloy_keys/${abloyKey.identity}/hand_in.json`, body);

      await _checkAbloyKeyStatus(leaseId, abloyKey.identity)

      const data = await _waitForAbloyKeyReadyToProgramm(leaseId, abloyKey.identity)

      if (!data || data.where_at != 'IN_STOCK') {
        console.log("Can't remove access from abloy key")
        throw "Can't remove access from abloy key"
      }

      dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, false))

      dispatch({
        type: UPSERT_ABLOY_KEY,
        payload: data
      })
      dispatch({
        type: RETURN_LEASE_KEY,
        payload: apartmentKeyId
      })
    } catch(error) {
      console.log(error)
      alert(fatalErrorMsg)
    }
  };

const activateAbloyKey = (leaseId, customerId, apartmentKeyId, abloyKey, startDate) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, true))
    dispatch(markAbloyKeyAsBusy(abloyKey))

    try {
      const body = JSON.stringify({
        hand_out: {
          customer_id: customerId,
          apartment_key_id: apartmentKeyId,
          key_valid_from: startDate,
          version: abloyKey.version
        }
      });
      await axiosClient.post(`/admin/leases/${leaseId}/abloy_keys/${abloyKey.identity}/hand_out.json`, body);

      await _checkAbloyKeyStatus(leaseId, abloyKey.identity)

      const data = await _waitForAbloyKeyReadyToProgramm(leaseId, abloyKey.identity)

      if (!data || data.where_at != "HANDED_OUT") {
        console.log("Can't grant access from abloy key")
        throw "Can't grant access from abloy key"
      }

      dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, false))

      dispatch({
        type: UPSERT_ABLOY_KEY,
        payload: data
      })
    } catch(error) {
      console.log(error)
      alert(fatalErrorMsg)
    }
  };

const looseAbloyKey = (leaseId, customerId, apartmentKeyId, abloyKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, true))
    dispatch(markAbloyKeyAsBusy(abloyKey))

    try {
      const body = JSON.stringify({
        declare_lost: {
          apartment_key_id: apartmentKeyId,
          version: abloyKey.version
        }
      });
      await axiosClient.post(`/admin/leases/${leaseId}/abloy_keys/${abloyKey.identity}/declare_lost.json`, body);

      await _checkAbloyKeyStatus(leaseId, abloyKey.identity)

      // Check it later
      const data = await _waitForAbloyKeyReadyToProgramm(leaseId, abloyKey.identity)

      dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, false))

      dispatch({
        type: UPSERT_ABLOY_KEY,
        payload: data
      })
      dispatch({
        type: REMOVE_LEASE_KEY,
        payload: apartmentKeyId
      })
      dispatch({
        type: LOOSE_LEASE_KEY,
        payload: { id: apartmentKeyId, stamp: abloyKey.marking }
      })

    } catch(error) {
      console.log(error)
      alert(fatalErrorMsg)
    }
  };

const brokenAbloyKey = (leaseId, customerId, apartmentKeyId, abloyKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, true))
    dispatch(markAbloyKeyAsBusy(abloyKey))

    try {
      const body = JSON.stringify({
        declare_broken: {
          apartment_key_id: apartmentKeyId,
          version: abloyKey.version
        }
      });
      await axiosClient.post(`/admin/leases/${leaseId}/abloy_keys/${abloyKey.identity}/declare_broken.json`, body);

      await _checkAbloyKeyStatus(leaseId, abloyKey.identity)

      // Check it later
      const data = await _waitForAbloyKeyReadyToProgramm(leaseId, abloyKey.identity)

      dispatch(setKeyUpdatingStatusByStamp(apartmentKeyId, abloyKey.marking, false))

      dispatch({
        type: UPSERT_ABLOY_KEY,
        payload: data
      })
      dispatch({
        type: REMOVE_LEASE_KEY,
        payload: apartmentKeyId
      })
      dispatch({
        type: BROKEN_LEASE_KEY,
        payload: { id: apartmentKeyId, stamp: abloyKey.marking }
      })

    } catch(error) {
      console.log(error)
      alert(fatalErrorMsg)
    }
  };
/* end abloy keys */

/* lease keys */
const addLeaseKey = (leaseId, stamp, given, selected = false) =>
  async dispatch => {
    const body = JSON.stringify({ new_key: { stamp: stamp, selected: selected }});
    const response = await axiosClient.post(`/admin/leases/${leaseId}/keys.json`, body);
    const data = response.data && response.data.apartment_key ? response.data.apartment_key : null;

    data._new = true

    let type = ADD_LEASE_KEY_TO_RECEIVED;

    if (given) {
      type = ADD_LEASE_KEY_TO_GIVEN;
    }

    dispatch(setKeyUpdatingStatusById(data.id, stamp, false))

    dispatch({
      type: type,
      payload: data
    })
  };

const looseLeaseKey = (leaseId, newKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, true))

    const response = await axiosClient.put(`/admin/leases/${leaseId}/keys/${newKey.id}/mark_lost.json`, {});

    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, false))

    if (response.status === 204) {
      dispatch({
        type: REMOVE_LEASE_KEY,
        payload: newKey.id
      })
      dispatch({
        type: LOOSE_LEASE_KEY,
        payload: newKey
      })
    }
  };

const returnLeaseKey = (leaseId, newKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, true))

    const response = await axiosClient.put(`/admin/leases/${leaseId}/keys/${newKey.id}/mark_returned.json`, {});

    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, false))

    if (response.status === 204) {
      dispatch({
        type: RETURN_LEASE_KEY,
        payload: newKey.id
      })
    }
  };

const removeLeaseKey = (leaseId, newKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, true))

    const response = await axiosClient.put(`/admin/leases/${leaseId}/keys/${newKey.id}/mark_removed.json`, {});

    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, false))

    if (response.status === 204) {
      dispatch({
        type: REMOVE_LEASE_KEY,
        payload: newKey.id
      })
    }
  };

const giveLeaseKey = (leaseId, newKey) =>
  async dispatch => {
    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, true))

    const response = await axiosClient.put(`/admin/leases/${leaseId}/keys/${newKey.id}/toggle_received.json`, {});

    dispatch(setKeyUpdatingStatusById(newKey.id, newKey.stamp, false))

    if (response.status === 204) {
      if (newKey.state == 'received') {
        dispatch({
          type: NOT_RECEIVED_LEASE_KEY,
          payload: newKey.id
        })
      } else {
        dispatch({
          type: RECEIVED_LEASE_KEY,
          payload: newKey.id
        })
      }
    }
  };


const setKeyUpdatingStatusById = (apartmentKeyId, stamp, updating) => {
  return {
    type: SET_KEY_UPDATING_STATUS_BY_ID,
    payload: { apartmentKeyId, stamp, updating }
  }
}

const setKeyUpdatingStatusByStamp = (apartmentKeyId, stamp, updating) => {
  return {
    type: SET_KEY_UPDATING_STATUS_BY_STAMP,
    payload: { apartmentKeyId, stamp, updating }
  }
}
/* end lease keys */

/* apartment transfer */
const createAbloyKeyStub = (abloyKeyCache) => {
  if (!abloyKeyCache) { return null }
  if (!abloyKeyCache.is_busy && abloyKeyCache.programmed) { return null }

  return {
    identity: abloyKeyCache.identity,
    marking: abloyKeyCache.marking,
    operational_status: 'OPERATIONAL',
    where_at: abloyKeyCache.where_at,
    key_holder_indentity: abloyKeyCache.key_holder_indentity,
    ready_to_programm: abloyKeyCache.ready_to_programm,
    programmed: abloyKeyCache.programmed,
    is_busy: abloyKeyCache.is_busy
  }
}

const fetchReceivedKeys = (keys) =>
  dispatch => {
    lodash.each(keys, (item) => {
      let abloyKeyStub = createAbloyKeyStub(item.abloy_key)
      if (!abloyKeyStub) { return }
      dispatch({
        type:    UPSERT_ABLOY_KEY,
        payload: abloyKeyStub
      })
    })
    dispatch({
      type: FETCH_RECEIVED_KEYS,
      payload: keys
    })
  }
const fetchGivenKeys = (keys) =>
  dispatch => {
    lodash.each(keys, (item) => {
      let abloyKeyStub = createAbloyKeyStub(item.abloy_key)
      if (!abloyKeyStub) { return }
      dispatch({
        type:    UPSERT_ABLOY_KEY,
        payload: abloyKeyStub
      })
    })
    dispatch({
      type: FETCH_GIVEN_KEYS,
      payload: keys
    })
  }

const fetchLostKeys = (keys) => {
  return {
    type: FETCH_LOST_KEYS,
    payload: keys
  }
};
const fetchBrokenKeys = (keys) => {
  return {
    type: FETCH_BROKEN_KEYS,
    payload: keys
  }
};
const transferReady = (transferId) =>
  async dispatch => {
    const response = await axiosClient.put(`/admin/transfers/${transferId}/mark_completed.json`, {});
    const data = response.data && response.data.apartment_transfer ? response.data.apartment_transfer.apartment_id : null;

    dispatch({
      type: TRANSFER_READY,
      payload: data
    })
  };

const submitComment = (transferId, notes) =>
  async dispatch => {
    const body = JSON.stringify({ apartment_transfer: { notes: notes }});
    const response = await axiosClient.put(`/admin/transfers/${transferId}.json`, body);
    const data = response.data && response.data.apartment_transfer ? response.data.apartment_transfer.apartment_id : null;

    dispatch({
      type: SUBMIT_COMMENT,
      payload: data
    })
  };

const actions = {
  markAbloyKeyAsBusy,
  fetchAbloyKeys,
  fetchAbloyKeyById,
  checkAbloyKeyStatus,
  upsertAbloyKey,
  activateAbloyKey,
  removeAccessAbloyKey,
  looseAbloyKey,
  brokenAbloyKey,
  addLeaseKey,
  looseLeaseKey,
  returnLeaseKey,
  removeLeaseKey,
  giveLeaseKey,
  fetchReceivedKeys,
  fetchGivenKeys,
  fetchLostKeys,
  fetchBrokenKeys,
  transferReady,
  submitComment,
  setKeyUpdatingStatusById,
};

export default actions;

